// A full page load after sign-in or MFA completion, so the app boots against the new session; an object so tests can spy on it.
export const pageNavigator = {
	go: (url: string): void => {
		window.location.assign(url);
	},
};
